import { useCallback, useState } from 'react';

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';

const readPages = (storageKey: string): string[] => {
	const value = localStorage.getItem(storageKey);
	return Array.isArray(value) ? (value as string[]) : [];
};

const isPageDismissed = (storageKey: string, contentId: string | undefined): boolean => {
	if (!contentId) {
		return false;
	}
	return readPages(storageKey).includes(contentId);
};

const markPageDismissed = (storageKey: string, contentId: string): void => {
	const previous = readPages(storageKey);
	const updated = [contentId, ...previous.filter((id) => id !== contentId)];
	localStorage.setItem(storageKey, updated);
};

export interface UseBannerDismissalResult {
	isDismissed: boolean;
	dismiss: () => void;
}

export const useBannerDismissal = (
	storageKey: string,
	contentId: string | undefined,
): UseBannerDismissalResult => {
	const [isDismissed, setIsDismissed] = useState(() => isPageDismissed(storageKey, contentId));

	const dismiss = useCallback(() => {
		if (contentId) {
			markPageDismissed(storageKey, contentId);
		}
		setIsDismissed(true);
	}, [storageKey, contentId]);

	return { isDismissed, dismiss };
};
